import { render } from "./SideBar.vue?vue&type=template&id=5dcfd145"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=5dcfd145&lang=scss"
script.render = render

export default script